(() => {
  const contextNode = document.querySelector('[data-mmd-cro-context]');
  if (!contextNode) return;

  let context;
  try {
    context = JSON.parse(contextNode.textContent);
  } catch {
    return;
  }

  const push = payload => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(payload);
  };

  if (context.pageType === 'product' && context.product) {
    push({ event: 'view_item', ecommerce: { currency: context.currency, value: context.product.price, items: [context.product] } });
  }

  document.addEventListener('submit', event => {
    const form = event.target.closest('form[action*="/cart/add"]');
    if (!form || !context.product) return;
    const variantInput = form.querySelector('[name="id"]');
    const quantityInput = form.querySelector('[name="quantity"]');
    const item = { ...context.product };
    if (variantInput && variantInput.value) item.item_variant = variantInput.value;
    const quantity = Math.max(1, Number.parseInt(quantityInput?.value || '1', 10) || 1);
    item.quantity = quantity;
    push({ event: 'add_to_cart', ecommerce: { currency: context.currency, value: item.price * quantity, items: [item] } });
  }, true);

  document.addEventListener('click', event => {
    const checkout = event.target.closest('[name="checkout"],a[href^="/checkout"]');
    if (!checkout || !context.cart || checkout.dataset.mmdTracked) return;
    checkout.dataset.mmdTracked = 'true';
    push({ event: 'begin_checkout', ecommerce: { currency: context.currency, value: context.cart.value, items: context.cart.items } });
  }, true);
})();

